import { Actions, createNamespace } from "../../../../flux/Actions";

const ns = createNamespace('SEARCH');
export const names = {
    SEARCH_PARAMS_UPDATED: ns('SEARCH_PARAMS_UPDATED')
};

export class SearchActions extends Actions
{
    updateSearchParams = (searchParams: any, dispatchToken: string) => this.dispatch(names.SEARCH_PARAMS_UPDATED, searchParams, dispatchToken);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/Actions.ts